import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import ZList from '../components/ZList';
import ZListItem from '../components/ZListItem';
import ZListItemIcon from '../components/ZListItemIcon';
import ZListItemText from '../components/ZListItemText';
import ZIcon from '../components/ZIcon';
import styles from '../components/sidebar-jss';
const LinkBtn = React.forwardRef(function LinkBtn(props, ref) { // eslint-disable-line
  return <NavLink to={props.to} {...props} innerRef={ref} />; // eslint-disable-line
});

function MainMenu(props) {
  const {
    classes,
    openSubMenu,
    open,
    dataMenu,
    toggleDrawerOpen,
  } = props;
  const [roleID, setRoleID] = useState(0)
  const [subscriptionID, setSubscriptionID] = useState(0)


  useEffect(() => {

    const path = props.history.location.pathname.split("/")
    if (path.length > 0) {
      props.openSubMenu(path[1])
    }
    // var session = localStorage.getItem('user');
    // var session_store = JSON.parse(session);
    // if (session_store != null) {
    //   setRoleID(session_store.roleId)
    //   setSubscriptionID(session_store.subId)
    // }
  }, [props.history.location.pathname])

  // useEffect(() => {
  //   setRoleID(props.roleId)
  //   setSubscriptionID(props.subId)
  // }, [props.roleId, props.subId, props.isAdmin])
  // screenshotEnable={props.screenshotEnable}

  const getMenus = menuArray => menuArray.map((item, index) => {
    if (props.offlineTime == item.OfflineRequest) {
      return (
        <ZListItem
          key={index}
          button
          component={LinkBtn}
          to={item.link}
          className={
            classNames(
              classes.head,
              item.icon ? classes.iconed : '',
              open.indexOf(item.key) > -1 ? classes.opened : '',
            )
          }
          onClick={() => openSubMenu(item.key, item.keyParent)}
        >
          {item.icon && (
            <ZListItemIcon className={classes.icon}>
              <ZIcon>{item.icon}</ZIcon>
            </ZListItemIcon>
          )}
          <ZListItemText classes={{ primary: classes.primary }} primary={item.name} />
        </ZListItem>
      );
    } 
  });

  return (
    <div>
      {getMenus(dataMenu)}
    </div>
  );
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  openSubMenu: PropTypes.func.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired,
  dataMenu: PropTypes.array.isRequired,
};

const openAction = (key, keyParent) => {
  return { type: 'OPEN_SUBMENU', key, keyParent }
}

const mapStateToProps = state => {
  return {
    force: state,
    open: state.ui.subMenuOpen
  }
};

// const mapDispatchToProps = dispatch => ({
//   openSubMenu: bindActionCreators(openAction, dispatch)
// });

// const MainMenuMapped = connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(MainMenu);

export default withStyles(styles) (MainMenu);

